import dayjs from 'dayjs';
import ENV from '~/environment';
import api from '../../api/http-common'
import { handleErrors } from '~/utils/helpers';

const downloadFileInAnotherWindow = (route, data?) =>
  fetch(`${ENV.API_URL}/${route}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
      body: JSON.stringify(data)
    }
  ).then(response => response.blob()).then(response => {
    const csvURL = window.URL.createObjectURL(response);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.target = '_blank'
    tempLink.click();
  }).catch(error => {
    handleErrors(error)
  });

const downloadFile = (route, name = 'trading_slot', data?, withoutDate = false) =>
  fetch(`${ENV.API_URL}/${route}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
      body: JSON.stringify(data)
    }
  ).then(response => response.blob()).then(response => {
    const csvURL = window.URL.createObjectURL(response);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', `${name}${withoutDate ? '' : `_${dayjs().format('D MMMM YYYY')}`}`);
    tempLink.click();
  }).catch(error => {
    handleErrors(error)
  });

const downloadFileWithName = (route, data?, headerName?) => {
  let name = ''
  return fetch(`${ENV.API_URL}/${route}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
      body: JSON.stringify(data)
    }
  ).then(response => {
    const raw = response.headers.get(headerName || 'Content-Name')
    try {
      name = decodeURIComponent(raw)
    } catch {
      name = raw
    }
    return response.blob()
  }).then(response => {
    const csvURL = window.URL.createObjectURL(response);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', name);
    tempLink.click();
  }).catch(error => {
    handleErrors(error)
  });
}

const downloadFileFromAws = (link, name) => {
  const tempLink = document.createElement('a');
  tempLink.href = link;
  tempLink.setAttribute('download', name);
  tempLink.click();
}

const getImageUrl = (url: string, data?) =>
  api.post(url, data)

export const DownloadService = {
  downloadFileInAnotherWindow,
  downloadFile,
  downloadFileFromAws,
  getImageUrl,
  downloadFileWithName
}